/**
 * @module FE-CU17_通知履歴画面
 */
import Header from '../../components/header/Header.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import TabHeader from '../../components/tabHeader/TabHeader.vue';
import NotificationHistorySelector from '../../components/notificationHistorySelector/NotificationHistorySelector.vue';
import NotificationHistoryTimeline from '../../components/NotificationHistoryTimeline/NotificationHistoryTimeline.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU17';

export default {
  name: 'NotificationHistory',
  components: {
    Header,
    PcPageTitle,
    BreadCrumbList,
    MobileFooter,
    TabHeader,
    NotificationHistorySelector,
    NotificationHistoryTimeline,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.通知履歴'),
      displayDistrictDialog: false,
      alarmDialog: false,
      cameraDialog: false,
      detectionDialog: false,
      categoryList: [
        {
          id: 1,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.ホームセキュリティボタン', //"ホームセキュリティ",
        },
        {
          id: 2,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.カメラボタン', //"カメラ",
        },
        {
          id: 3,
          isChecked: true,
          label: '$vuetify.FECU17通知履歴画面.お知らせボタン', //"お知らせ",
        },
      ],
      displayDistrictList: [],
      alarmList: [
        {
          id: 1,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.警備操作',
          //"警報操作",
        },
        {
          id: 2,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.侵入',
          //"侵入",
        },
        {
          id: 3,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.火災',
          // "火災",
        },
        {
          id: 4,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.火災復旧',
          // "火災復旧",
        },
        {
          id: 5,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.ガス',
          // "ガス",
        },
        {
          id: 6,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.ガス復旧',
          // "ガス復旧",
        },
        {
          id: 7,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.非常救急',
          // "非常救急",
        },
        {
          id: 8,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.非常救急復旧',
          // "非常救急復旧",
        },
        {
          id: 9,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.ライフリズム',
          // "ライフリズム",
        },
        {
          id: 10,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.ライフリズム復旧',
          // "ライフリズム復旧",
        },
        {
          id: 11,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.設備',
          // "設備",
        },
        {
          id: 12,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.設備復旧',
          // "設備復旧",
        },
        {
          id: 13,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.電池切れ',
          // "電池切れ",
        },
        {
          id: 14,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.電池切れ復旧',
          // "電池切れ復旧",
        },
        {
          id: 15,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.機器異常',
          // "機器異常",
        },
        {
          id: 16,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.機器異常復旧',
          // "機器異常復旧",
        },
        {
          id: 17,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.見守り',
          // "見守り",
        },
        {
          id: 18,
          isChecked: true,
          label: '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.お知らせ',
          isHidden: true,
          // "お知らせ",
        },
      ],
      cameraList: [],
      detectionList: [
        {
          id: 1,
          isChecked: false,
          label: '$vuetify.FECU17通知履歴画面.検知種別選択チェックボックス.動体検知', //"動体検知・ローバッテリー"
        },
      ],
      // APP_1701(通知履歴データ取得API)後の状態を保持
      initInfo: {
        displayDistrictList: [],
        alarmList: [],
        cameraList: [],
        detectionList: [],
      },
      roleList: {},
      tabNumber: 0,
      dummyTabNumber: 0,
      tabs: [
        {
          id: 1,
          title: '$vuetify.FECU17通知履歴画面.全通知ボタン', // "全通知"
        },
        {
          id: 2,
          title: '$vuetify.FECU17通知履歴画面.ホーム', // "ホーム",
          title2: '$vuetify.FECU17通知履歴画面.セキュリティ', // "セキュリティ"
          isDisabled: true,
        },
        {
          id: 3,
          title: '$vuetify.FECU17通知履歴画面.カメラボタン', //"カメラ"
          isDisabled: true,
        },
        {
          id: 4,
          title: '$vuetify.FECU17通知履歴画面.お知らせ', //"お知らせ"
        },
      ],
      tabsAreaPosition: {
        0: '163px', // 全通知
        1: '275px', // ホームセキュリティ/
        2: '275px', // カメラ
        3: '163px', // お知らせ
      },
      lastUpdate: '',
      // 通知履歴一覧を格納
      notificationList: [],
      notificationListUnspecified: [],
      modified: '',
      displayDistrictDialogText: '',
      alarmDialogText: '',
      cameraDialogText: '',
      detectionDialogText: '',
      fromType: this.$store.state.fromType, // パンくず
      CONSTANTS: CONSTANTS,
      cu9916Data: {},
      isShowTimeline: true,
      isShowPage: false, //#27159
    };
  },
  watch: {
    tabNumber(newVal) {
      this.isShowTimeline = false;
      this.dummyTabNumber = newVal;
      this.$store.commit('setNotificationHistoryTabNumber', {
        notificationHistoryTabNumber: newVal,
      });

      // delay 1 ms for hide redundant animation
      setTimeout(() => {
        this.isShowTimeline = true;
      }, 1);
    },
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.通知履歴'), //"通知履歴",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU17通知履歴画面.C0001'),
        lastUpdate: vm.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.最終更新日時'),
        alarmList: [
          {
            id: 1,
            isChecked: this.alarmList[0].isChecked,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.警備操作'
            ), //"警報操作",
          },
          {
            id: 2,
            isChecked: this.alarmList[1].isChecked,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.侵入'
            ), //"侵入",
          },
          {
            id: 3,
            isChecked: this.alarmList[2].isChecked,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.火災'
            ), // "火災",
          },
          {
            id: 4,
            isChecked: this.alarmList[3].isChecked,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.火災復旧'
            ), // "火災復旧",
          },
          {
            id: 5,
            isChecked: this.alarmList[4].isChecked,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.ガス'
            ), // "ガス",
          },
          {
            id: 6,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.ガス復旧'
            ), // "ガス復旧",
          },
          {
            id: 7,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.非常救急'
            ), // "非常救急",
          },
          {
            id: 8,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.非常救急復旧'
            ), // "非常救急復旧",
          },
          {
            id: 9,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.ライフリズム'
            ), // "ライフリズム",
          },
          {
            id: 10,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.ライフリズム復旧'
            ), // "ライフリズム復旧",
          },
          {
            id: 11,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.設備'
            ), // "設備",
          },
          {
            id: 12,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.設備復旧'
            ), // "設備復旧",
          },
          {
            id: 13,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.電池切れ'
            ), // "電池切れ",
          },
          {
            id: 14,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.電池切れ復旧'
            ), // "電池切れ復旧",
          },
          {
            id: 15,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.機器異常'
            ), // "機器異常",
          },
          {
            id: 16,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.機器異常復旧'
            ), // "機器異常復旧",
          },
          {
            id: 17,
            isChecked: false,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.見守り'
            ), // "見守り",
          },
          {
            id: 18,
            isChecked: true,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.警報種別選択チェックボックス.お知らせ'
            ), // "お知らせ",
            isHidden: true,
          },
        ],
        detectionList: [
          {
            id: 1,
            isChecked: this.detectionList[0].isChecked,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU17通知履歴画面.検知種別選択チェックボックス.動体検知'
            ), //"動体検知・ローバッテリー"
          },
        ],
      };
    },
    changeAreaPosition() {
      return this.tabsAreaPosition[this.tabNumber];
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 初期処理
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     */
    init: async function (queries, method) {
      let promiseList = [];
      const param = '/api/common/getRoleList';
      promiseList.push(await this.APP_CU9916(param, queries, method));
      promiseList.push(await this.updateNotifications(this.cu9916Data));
      promiseList.push(this.saveInitInfo());
      await Promise.all(promiseList);

      for (let i = 0; i < this.cu9916Data.contentsInfo.displayDistrictInfoList.length; i++) {
        if (
          this.cu9916Data.contentsInfo.displayDistrictInfoList[i].userAuthority.notificationHistory
        ) {
          // 「通知/通知履歴」に一つでもtrueがある場合、ホームセキュリティボタンを活性する
          this.categoryList[0].isDisabled = false;
          this.categoryList[0].isChecked = true;
          this.tabs[1].isDisabled = false;
          break;
        }
      }

      for (let i = 0; i < this.cu9916Data.contentsInfo.cameraInfoList.length; i++) {
        if (this.cu9916Data.contentsInfo.cameraInfoList[i].userAuthority.notificationHistory) {
          // 「通知/通知履歴」に一つもtrueある場合、カメラボタンを活性する
          this.categoryList[1].isDisabled = false;
          this.categoryList[1].isChecked = true;
          this.tabs[2].isDisabled = false;
          break;
        }
      }
      this.$_setLoading(false);
    },
    /**
     * 通知履歴表示更新処理
     * @param {*} cu9916 ユーザー権限
     */
    updateNotifications: async function (cu9916) {
      const param = '/api/notificationHistory/getNotificationHistory';
      const method = 'post';
      const queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo'),
      };
      const cu1701 = await this.APP_CU1701(param, queries, method);

      // 通知をマッピング
      this.lastUpdate = cu1701.contentsInfo.notificationInfo.lastUpdate.replace(/-/g, '/');

      cu1701.contentsInfo.notificationInfo.allNotificationList.sort((prev, next) => {
        const prevDate = new Date(prev.postedDatetime);
        const nextDate = new Date(next.postedDatetime);
        // 投稿日時の昇順に並び替え
        return prevDate - nextDate;
      });
      let allNotificationList = cu1701.contentsInfo.notificationInfo.allNotificationList;
      let allNotificationListUnspecified =
        cu1701.contentsInfo.notificationInfo.allNotificationListUnspecified;

      // 通知履歴に設定を追加
      allNotificationList = this.notificationSetting(cu9916, allNotificationList);
      allNotificationListUnspecified = this.notificationSetting(
        cu9916,
        allNotificationListUnspecified
      );

      this.notificationList = allNotificationList;
      this.notificationListUnspecified = allNotificationListUnspecified;

      // 対象地区のチェックボックスマッピング
      cu1701.contentsInfo.displayDistrictFilterList.forEach((element, idx) => {
        if (this.displayDistrictList[idx]) {
          this.displayDistrictList[idx].id = element.idx;
          this.displayDistrictList[idx].isChecked = element.filterStatus;
          this.displayDistrictList[idx].label = element.displayDistrictNickname;
          this.displayDistrictList[idx].customerNumber = element.customerNumber;
          this.displayDistrictList[idx].districtSplitNumber = element.districtSplitNumber;
          this.displayDistrictList[idx].modified = element.modified;
        } else {
          this.displayDistrictList.push({
            id: idx,
            isChecked: element.filterStatus,
            // label:
            //   element.displayDistrictNickname.length < 12
            //     ? element.displayDistrictNickname
            //     : element.displayDistrictNickname.slice(0, 11) + '…',
            label: element.displayDistrictNickname,
            customerNumber: element.customerNumber,
            districtSplitNumber: element.districtSplitNumber,
            modified: element.modified,
          });
        }
      });

      this.switchLabel(
        this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.対象地区'),
        this.displayDistrictList
      );

      // 警報種別のチェックボックスマッピング
      this.alarmList[0].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.securityOperationInfo.filterStatus;
      this.alarmList[1].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.intrusionInfo.filterStatus;
      this.alarmList[2].isChecked = cu1701.contentsInfo.alarmTypeFilterList.fireInfo.filterStatus;
      this.alarmList[3].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.fireRecoveryInfo.filterStatus;
      this.alarmList[4].isChecked = cu1701.contentsInfo.alarmTypeFilterList.gasInfo.filterStatus;
      this.alarmList[5].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.gasRecoveryInfo.filterStatus;
      this.alarmList[6].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.emergencyInfo.filterStatus;
      this.alarmList[7].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.emergencyRecoveryInfo.filterStatus;
      this.alarmList[8].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.lifeRhythmInfo.filterStatus;
      this.alarmList[9].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.lifeRhythmRecoveryInfo.filterStatus;
      this.alarmList[10].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.equipmentInfo.filterStatus;
      this.alarmList[11].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.equipmentRecoveryInfo.filterStatus;
      this.alarmList[12].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.lowBatteryInfo.filterStatus;
      this.alarmList[13].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.lowBatteryRecoveryInfo.filterStatus;
      this.alarmList[14].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.equipmentErrorInfo.filterStatus;
      this.alarmList[15].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.equipmentErrorRecoveryInfo.filterStatus;
      this.alarmList[16].isChecked =
        cu1701.contentsInfo.alarmTypeFilterList.watchOverInfo.filterStatus;
      this.alarmList[17].isChecked = cu1701.contentsInfo.alarmTypeFilterList.newsInfo.filterStatus;

      this.switchLabel(
        this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.警報種別'),
        this.alarmList
      );

      // カメラのチェックボックスマッピング
      cu1701.contentsInfo.cameraFilterList.forEach((element, idx) => {
        if (this.cameraList[idx]) {
          this.cameraList[idx].id = element.idx;
          this.cameraList[idx].isChecked = element.filterStatus;
          this.cameraList[idx].label = element.cameraNickName;
          this.cameraList[idx].deviceID = element.deviceID;
          this.cameraList[idx].modified = element.modified;
        } else {
          this.cameraList.push({
            id: idx,
            isChecked: element.filterStatus,
            // label:
            //   element.cameraNickName.length < 12
            //     ? element.cameraNickName
            //     : element.cameraNickName.slice(0, 11) + '…',
            label: element.cameraNickName,
            deviceID: element.deviceID,
            modified: element.modified,
          });
        }
      });

      this.switchLabel(this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.カメラ'), this.cameraList);

      // 検知種別のチェックボックスマッピング
      this.detectionList[0].isChecked =
        cu1701.contentsInfo.detectionTypeFilterList.motionSensingInfo.filterStatus;

      this.switchLabel(
        this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.検知種別'),
        this.detectionList
      );

      // 更新日時を保存
      this.modified = cu1701.contentsInfo.modified;
    },
    /**
     * 通知履歴設定追加処理
     * @param {*} cu9916 ユーザー権限
     * @param {*} notificationSettingList 全通知一覧
     * @returns notificationSettingList 全通知一覧
     */
    notificationSetting: function (cu9916, notificationSettingList) {
      var customerArray = []; // まとめた結果を格納する
      let onlyOnce = false;
      notificationSettingList.forEach((list) => {
        if (list.notificationType == 1) {
          // ホームセキュリティのcustomerNumberとdistrictSplitNumberをまとめる
          var customerObject = {
            customerNumber: list.customerNumber,
            districtSplitNumber: list.districtSplitNumber,
          };

          let sameFlag = false;
          for (let i = 0; customerArray.length > i; i++) {
            if (
              customerArray[i].customerNumber == list.customerNumber &&
              customerArray[i].districtSplitNumber == list.districtSplitNumber
            ) {
              sameFlag = true;
            }
          }

          if (customerArray.length == 0) {
            customerArray.push(customerObject);
          } else if (!sameFlag) {
            customerArray.push(customerObject);
          }
        }

        // 前回ログイン以降の通知 を表示
        if (!onlyOnce && list.isNewMessageLabel) {
          list.newMessageFromHere = true;
          onlyOnce = true;
        }
      });

      customerArray.forEach((list) => {
        for (let i = 0; cu9916.contentsInfo.displayDistrictInfoList.length > i; i++) {
          let list9916 = cu9916.contentsInfo.displayDistrictInfoList[i];
          if (list.customerNumber != null && list.districtSplitNumber != null) {
            if (
              list.customerNumber == list9916.customerNumber &&
              list.districtSplitNumber == list9916.districtSplitNumber &&
              list9916.userAuthority.lockUpCheck
            ) {
              // 詳細は【 コチラ 】の表示制御を設定
              notificationSettingList.forEach((notification) => {
                if (
                  notification.customerNumber == list.customerNumber &&
                  notification.districtSplitNumber == list.districtSplitNumber
                ) {
                  notification.warningCheck = list9916.userAuthority.lockUpCheck;
                }
              });
            }
          }
        }
      });

      return notificationSettingList;
    },
    /**
     * APP_1701(通知履歴データ取得API)後の状態を保持する処理
     */
    saveInitInfo: function () {
      this.initInfo = {
        displayDistrictList: [],
        alarmList: [],
        cameraList: [],
        detectionList: [],
      };

      this.initInfo.displayDistrictList = JSON.parse(JSON.stringify(this.displayDistrictList));
      this.initInfo.alarmList = JSON.parse(JSON.stringify(this.alarmList));
      this.initInfo.cameraList = JSON.parse(JSON.stringify(this.cameraList));
      this.initInfo.detectionList = JSON.parse(JSON.stringify(this.detectionList));
    },
    /**
     * ユーザー権限一覧取得実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     */
    APP_CU9916: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: [
            //       {
            //         customerNumber: "1111111",
            //         districtSplitNumber: "1111111",
            //         displayDistrictUserType: 1,
            //         userAuthority: {
            //           securityOperation: false,
            //           rushOrder: false,
            //           notificationHistory: false,
            //           deviceControl: false,
            //           contact: false,
            //           nicknameSetting: false,
            //           IDCardKeyInfoSetting: false,
            //           watchOverInfoDeliverySetting: false,
            //           lockUpCheck: false,
            //           targetAtHomeSetting: false,
            //           userManagement: false,
            //           emergencyContact: false,
            //         },
            //       },
            //       {
            //         customerNumber: "222222222",
            //         districtSplitNumber: "1111111",
            //         displayDistrictUserType: 1,
            //         userAuthority: {
            //           securityOperation: false,
            //           rushOrder: false,
            //           notificationHistory: true, //通知
            //           deviceControl: false,
            //           contact: false,
            //           nicknameSetting: false,
            //           IDCardKeyInfoSetting: false,
            //           watchOverInfoDeliverySetting: false,
            //           lockUpCheck: false,
            //           targetAtHomeSetting: false,
            //           userManagement: false,
            //           emergencyContact: false,
            //         },
            //       },
            //     ],
            //     cameraInfoList: [
            //       {
            //         customerNumber: "customerNumber",
            //         districtSplitNumber: "1",
            //         deviceID: "1111",
            //         cameraUserType: 1,
            //         userAuthority: {
            //           anticrimeCameraVideos: true,
            //           rushOrder: true,
            //           notificationHistory: false, //通知
            //           contact: true,
            //           nicknameSetting: true,
            //           userManagement: true,
            //           emergencyContact: true,
            //         },
            //       },
            //       {
            //         customerNumber: "customerNumber2",
            //         districtSplitNumber: 2,
            //         deviceID: "1111",
            //         cameraUserType: 1,
            //         userAuthority: {
            //           anticrimeCameraVideos: true,
            //           rushOrder: true,
            //           notificationHistory: true, //通知
            //           contact: true,
            //           nicknameSetting: true,
            //           userManagement: true,
            //           emergencyContact: true,
            //         },
            //       },
            //     ],
            //   },
            // };
            this.cu9916Data = apiData;

            // ヘッダー・フッターホームセキュリティ表示フラグ（Navのホームセキュリティボタンも表示制御する。）
            if (apiData.contentsInfo.displayDistrictInfoList.length == 0) {
              this.$store.state.isTopHomeSecurityActive = false;
              this.$store.state.disableHomeSecurityActive = true;
            } else {
              this.$store.state.isTopHomeSecurityActive = true;
              this.$store.state.disableHomeSecurityActive = false;
            }

            let userAuthorityCamera = false;
            apiData.contentsInfo.cameraInfoList.forEach((cameraInfo) => {
              if (
                cameraInfo.userAuthority.anticrimeCameraVideos == true ||
                cameraInfo.userAuthority.rushOrder == true ||
                cameraInfo.userAuthority.notificationHistory == true ||
                cameraInfo.userAuthority.contact == true ||
                cameraInfo.userAuthority.nicknameSetting == true ||
                cameraInfo.userAuthority.userManagement == true ||
                cameraInfo.userAuthority.emergencyContact == true
              ) {
                userAuthorityCamera = true;
                return;
              }
            });
            if (!userAuthorityCamera || apiData.contentsInfo.cameraInfoList.length == 0) {
              this.$store.state.isTopCameraActive = false;
              // APP_9916のレスポンスのカメラ情報一覧で、ユーザー権限が全てfalseの場合、カメラボタンを非表示にする。
              this.$store.state.disableCamera = true;
            } else {
              this.$store.state.isTopCameraActive = true;
              // APP_9916のレスポンスのカメラ情報一覧で、ユーザー権限に一つでもtrueがある場合、カメラボタンを表示する。
              this.$store.state.disableCamera = false;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU9916>>>");
      // return apiData;
    },
    /**
     * 通知履歴データ取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    APP_CU1701: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // バックからもらったデータ
            // apiData = {
            //   contentsInfo:{
            //     notificationInfo: {lastUpdate:"2022-07-26 16:16:08",
            //     allNotificationList:[
            //       {notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:29:09.650",contentType:0,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:29:09.650",contentType:0,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:29:09.650",contentType:0,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:29:09.650",contentType:0,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:29:09.650",contentType:0,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:29:09.650",contentType:0,serviceType:"A03",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:29:09.650",contentType:0,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:34:31.306",contentType:0,serviceType:"A18",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:35:10.339",contentType:0,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/27 13:35:32.642",contentType:1,serviceType:"M02",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/28 11:30:20.672",contentType:1,serviceType:"M02",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/29 10:00:28.770",contentType:1,serviceType:"M02",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/29 10:00:28.770",contentType:1,serviceType:"M03",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/29 10:01:20.889",contentType:0,serviceType:"A16",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/29 10:01:51.593",contentType:0,serviceType:"A14",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/29 10:02:53.314",contentType:0,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/29 10:03:11.041",contentType:0,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/30 13:19:06.392",contentType:1,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/30 13:19:26.860",contentType:1,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/30 13:20:02.988",contentType:1,serviceType:"A03",customerNumber:"700000042",districtSplitNumber:"0002",operatorInfo:"",sensorName:"",securityDestinationName:"警備先42地区2",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/30 13:20:22.459",contentType:1,serviceType:"A04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/30 13:20:40.052",contentType:1,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/30 14:28:31.908",contentType:1,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/30 14:29:56.853",contentType:1,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/06/30 14:31:09.276",contentType:1,serviceType:"A16",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/06/30 18:24:00.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"履歴ないようないよう",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/06/30 18:51:00.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"つうちりれき",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/06/30 18:52:38.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"つうちりれきおしらせ",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/01 10:00:00.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"通知履歴\nないよう\nないよう\nないよう\n",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/01 13:05:11.778",contentType:1,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/01 13:06:36.171",contentType:1,serviceType:"M02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/01 17:29:19.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"かきくけこ",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/03 10:24:00.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"testtesttest",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/04 17:11:53.750",contentType:1,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/04 17:12:35.855",contentType:0,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/04 17:12:45.239",contentType:0,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/04 17:13:00.431",contentType:1,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/04 17:13:11.887",contentType:1,serviceType:"A08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/06 10:54:38.791",contentType:0,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/06 11:32:20.851",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/06 16:25:00.949",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/06 16:26:07.382",contentType:1,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/13 13:41:31.144",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/14 11:51:52.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"お知らせ内容です",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 12:05:42.167",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 12:08:12.872",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 13:07:49.412",contentType:0,serviceType:"S04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 13:21:47.710",contentType:0,serviceType:"S05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 14:00:13.604",contentType:0,serviceType:"S06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 14:03:04.981",contentType:0,serviceType:"S07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 14:19:44.864",contentType:0,serviceType:"S08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 14:26:35.096",contentType:1,serviceType:"M02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 14:44:27.985",contentType:0,serviceType:"M02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 14:49:39.865",contentType:1,serviceType:"M03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 15:08:20.051",contentType:1,serviceType:"M03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 15:23:09.824",contentType:0,serviceType:"M03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 15:52:45.400",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 15:58:44.625",contentType:0,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 16:45:48.709",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 16:47:33.871",contentType:0,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 16:51:09.557",contentType:1,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 16:52:36.356",contentType:0,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 16:53:48.022",contentType:1,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 17:04:30.161",contentType:0,serviceType:"A03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 17:16:24.657",contentType:1,serviceType:"A03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 17:30:03.514",contentType:0,serviceType:"A04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 17:33:08.284",contentType:1,serviceType:"A04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 18:29:53.031",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 18:30:01.193",contentType:0,serviceType:"S04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 18:30:08.794",contentType:0,serviceType:"S05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 18:30:21.097",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 18:30:28.008",contentType:0,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 19:07:59.141",contentType:0,serviceType:"A19",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/14 19:08:55.645",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 14:38:03.612",contentType:0,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 14:40:13.211",contentType:1,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 14:43:18.644",contentType:1,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 14:44:18.860",contentType:1,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 14:47:19.051",contentType:0,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 15:08:01.733",contentType:1,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 15:13:47.191",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 15:54:04.696",contentType:0,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 15:54:27.211",contentType:1,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 15:58:18.413",contentType:0,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:01:23.237",contentType:1,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:01:55.165",contentType:1,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:03:08.124",contentType:1,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:03:44.300",contentType:1,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:05:54.454",contentType:1,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:18:15.750",contentType:1,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:31:11.768",contentType:1,serviceType:"A08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:31:50.391",contentType:0,serviceType:"A08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:37:24.087",contentType:1,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:41:12.761",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:41:45.120",contentType:0,serviceType:"A08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:43:03.680",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:43:42.232",contentType:1,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:45:04.640",contentType:1,serviceType:"A08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:46:06.153",contentType:0,serviceType:"A09",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:48:46.232",contentType:1,serviceType:"A09",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:51:37.240",contentType:0,serviceType:"A10",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:54:13.585",contentType:1,serviceType:"A10",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:56:53.250",contentType:0,serviceType:"A11",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 16:59:34.498",contentType:1,serviceType:"A11",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 17:00:20.538",contentType:0,serviceType:"S04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 17:01:09.811",contentType:1,serviceType:"A11",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 17:02:22.923",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 17:11:56.493",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 17:27:31.573",contentType:0,serviceType:"A19",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/15 17:29:19.519",contentType:0,serviceType:"A18",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/17 19:22:46.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"3連休二日目、皆さま如何お過ごしでしょうか。",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 09:23:31.394",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 09:24:38.063",contentType:0,serviceType:"S04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 09:28:02.730",contentType:0,serviceType:"S05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 09:28:43.785",contentType:0,serviceType:"S06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 09:30:24.818",contentType:0,serviceType:"S07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 09:33:06.417",contentType:0,serviceType:"S07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 10:24:37.538",contentType:0,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 10:27:32.225",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 11:01:37.109",contentType:0,serviceType:"S08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 11:01:40.685",contentType:0,serviceType:"S08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 11:01:43.422",contentType:0,serviceType:"S08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 11:01:49.797",contentType:0,serviceType:"S08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 11:01:53.221",contentType:0,serviceType:"S08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 12:07:29.751",contentType:0,serviceType:"A09",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 12:08:24.486",contentType:0,serviceType:"A12",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 12:12:35.871",contentType:1,serviceType:"A12",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 12:13:56.383",contentType:0,serviceType:"A13",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 12:55:47.270",contentType:0,serviceType:"A13",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 12:56:12.878",contentType:0,serviceType:"A13",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 12:56:41.959",contentType:1,serviceType:"A13",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:02:36.622",contentType:0,serviceType:"A14",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:05:21.856",contentType:1,serviceType:"A14",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:09:01.896",contentType:0,serviceType:"A15",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:09:16.496",contentType:0,serviceType:"A15",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:11:22.432",contentType:1,serviceType:"A15",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:14:25.305",contentType:0,serviceType:"A16",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:16:05.513",contentType:1,serviceType:"A16",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:19:40.625",contentType:0,serviceType:"A17",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:21:21.626",contentType:1,serviceType:"A17",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:24:41.658",contentType:0,serviceType:"A18",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:26:09.964",contentType:1,serviceType:"A18",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:29:03.269",contentType:0,serviceType:"A19",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:29:03.269",contentType:0,serviceType:"A19",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:31:59.938",contentType:1,serviceType:"A19",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:41:24.085",contentType:1,serviceType:"A11",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:46:14.878",contentType:1,serviceType:"A08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:47:56.102",contentType:1,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 13:50:24.999",contentType:1,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 16:00:37.399",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/19 19:36:07.326",contentType:0,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/20 13:48:00.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"内容",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/20 14:21:24.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"お知らせテスト",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/20 18:01:10.259",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/20 18:07:01.124",contentType:0,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/20 19:32:26.989",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/20 19:32:26.989",contentType:0,serviceType:"S04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/20 19:32:26.989",contentType:0,serviceType:"S05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/20 19:40:24.548",contentType:0,serviceType:"S06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/20 19:43:02.621",contentType:0,serviceType:"S07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/20 19:44:58.700",contentType:0,serviceType:"S08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 10:06:47.774",contentType:0,serviceType:"S08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 10:10:26.860",contentType:0,serviceType:"M02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 10:46:37.483",contentType:1,serviceType:"M02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 10:49:22.594",contentType:0,serviceType:"M03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:41:42.866",contentType:1,serviceType:"N01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:43:54.153",contentType:0,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:45:43.546",contentType:1,serviceType:"A01",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:47:11.379",contentType:0,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:50:34.586",contentType:1,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:51:21.050",contentType:1,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:53:40.435",contentType:0,serviceType:"A03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:54:37.243",contentType:1,serviceType:"A02",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:54:55.483",contentType:1,serviceType:"A03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:56:11.891",contentType:0,serviceType:"A04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:57:44.747",contentType:1,serviceType:"A04",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:59:03.355",contentType:0,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 11:59:47.324",contentType:1,serviceType:"A05",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:00:28.235",contentType:0,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:01:15.635",contentType:1,serviceType:"A06",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:02:24.795",contentType:0,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:03:10.635",contentType:1,serviceType:"A07",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:05:53.812",contentType:0,serviceType:"A08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:06:53.316",contentType:1,serviceType:"A08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:08:42.517",contentType:0,serviceType:"A09",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:09:56.572",contentType:1,serviceType:"A09",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:11:43.877",contentType:0,serviceType:"A10",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:12:27.748",contentType:1,serviceType:"A10",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:14:25.566",contentType:0,serviceType:"A11",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 12:15:13.238",contentType:1,serviceType:"A11",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:03:18.041",contentType:0,serviceType:"A12",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:04:17.913",contentType:1,serviceType:"A12",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:05:41.033",contentType:0,serviceType:"A13",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:06:18.961",contentType:1,serviceType:"A13",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:11:19.068",contentType:0,serviceType:"A14",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:12:27.547",contentType:1,serviceType:"A14",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:13:59.978",contentType:0,serviceType:"A15",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:14:39.762",contentType:1,serviceType:"A15",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:16:09.628",contentType:0,serviceType:"A16",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:16:52.331",contentType:1,serviceType:"A16",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 13:19:15.996",contentType:0,serviceType:"A17",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 14:24:02.636",contentType:1,serviceType:"A17",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 14:25:58.798",contentType:0,serviceType:"A18",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 14:26:54.150",contentType:1,serviceType:"A18",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 14:27:57.853",contentType:0,serviceType:"A19",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 14:28:54.454",contentType:1,serviceType:"A19",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/21 14:39:39.825",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/21 15:30:00.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"テスト",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/21 16:01:10.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"お知らせ内容\n(通知履歴)",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/21 16:02:25.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"ああああああ",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/21 16:05:41.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"お知らせ内容\n(通知履歴)",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/21 16:44:10.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"test",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/22 10:14:34.514",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"暗証番号",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/22 11:48:00.147",contentType:0,serviceType:"S08",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/22 12:55:24.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"test",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/22 13:38:00.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"削除テスト用データ",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/24 01:00:50.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"お知らせ内容(通知履歴)は必須です。",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/24 11:02:52.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"お知らせ内容\n(通知履歴)",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/25 11:32:07.957",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"暗証番号",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:1,postedName:"HOME ALSOK",postedDatetime:"2022/07/25 11:40:09.391",contentType:0,serviceType:"S03",customerNumber:"700000042",districtSplitNumber:"0001",operatorInfo:"1234567890カードユーザー名1",sensorName:"TB装置42名称1-1",securityDestinationName:"警備先42地区1",deviceID:null,cameraNickname:null,notificationMessage:null,isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/25 14:02:14.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"お知らせ内容\nhttps://www.alsok.co.jp/",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/25 15:30:46.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"お知らせ内容\n(通知履歴)",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/25 16:47:54.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"aaa",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/25 17:15:42.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:" <p>サーバーメンテナンスのため一時的にアプリ利用ができなくなります。</p>\n<p>警備機器ホームアルソック XS をご利用のお客様は<a herf=\"https://www.alsok.co.jp/person/homealsok/\">ALSOK ホームページ</a>をご確認ください。</p>\n",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/26 09:34:42.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"バッチによるEメール通知テスト",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/26 09:36:19.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"1バッチによるEメール通知テスト",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/26 10:58:38.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"え",isNewMessageLabel:false,isPersonNotification:false}
            //       ,{notificationType:3,postedName:"ALSOK",postedDatetime:"2022/07/26 11:00:00.000",contentType:null,serviceType:null,customerNumber:null,districtSplitNumber:null,operatorInfo:null,sensorName:null,securityDestinationName:null,deviceID:null,cameraNickname:null,notificationMessage:"お知らせ内容(通知履歴)1234567890",isNewMessageLabel:false,isPersonNotification:false}
            //     ]},
            //     displayDistrictFilterList:[
            //       {displayDistrictNickname:"警備先42地区1",customerNumber:"700000042",districtSplitNumber:"0001",filterStatus:true,modified:"2022/07/21 17:36:21.917"},
            //       {displayDistrictNickname:"警備先42地区2",customerNumber:"700000042",districtSplitNumber:"0002",filterStatus:true,modified:"2022/07/20 09:28:41.332"}
            //     ],
            //     alarmTypeFilterList:{
            //       securityOperationInfo:{filterStatus:true},
            //       intrusionInfo:{filterStatus:true},
            //       fireInfo:{filterStatus:true},
            //       fireRecoveryInfo:{filterStatus:true},
            //       gasInfo:{filterStatus:true},
            //       gasRecoveryInfo:{filterStatus:true},
            //       emergencyInfo:{filterStatus:true},
            //       emergencyRecoveryInfo:{filterStatus:true},
            //       lifeRhythmInfo:{filterStatus:true},
            //       lifeRhythmRecoveryInfo:{filterStatus:true},
            //       equipmentInfo:{filterStatus:true},
            //       equipmentRecoveryInfo:{filterStatus:true},
            //       lowBatteryInfo:{filterStatus:true},
            //       lowBatteryRecoveryInfo:{filterStatus:true},
            //       equipmentErrorInfo:{filterStatus:true},
            //       equipmentErrorRecoveryInfo:{filterStatus:true},
            //       newsInfo:{filterStatus:true}
            //     },
            //     cameraFilterList:[],
            //     detectionTypeFilterList:{motionSensingInfo:{filterStatus:false}},
            //     modified:"2022/07/26 16:14:07.766"
            //   }
            // };

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     notificationInfo: {
            //       lastUpdate: "2022-05-30 12:00:00",
            //       allNotificationList: [
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-01 01:00:00",
            //           contentType: 1,
            //           serviceType: "N01",
            //           customerNumber: "N01-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 1,
            //           serviceType: "A01",
            //           customerNumber: "A01-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 0,
            //           serviceType: "A01",
            //           customerNumber: "A01-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 1,
            //           serviceType: "A06",
            //           customerNumber: "A06-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 0,
            //           serviceType: "A06",
            //           customerNumber: "A06-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 1,
            //           serviceType: "A07",
            //           customerNumber: "A07-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 0,
            //           serviceType: "A07",
            //           customerNumber: "A07-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 1,
            //           serviceType: "A08",
            //           customerNumber: "A08-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 0,
            //           serviceType: "A07",
            //           customerNumber: "A07-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 1,
            //           serviceType: "A09",
            //           customerNumber: "A09-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 0,
            //           serviceType: "A09",
            //           customerNumber: "A09-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 1,
            //           serviceType: "A10",
            //           customerNumber: "A10-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-05 01:00:00",
            //           contentType: 0,
            //           serviceType: "A10",
            //           customerNumber: "A10-11111",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "リビングカメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "綜警 S03",
            //           postedDatetime: "2022-05-20 12:00:00",
            //           contentType: 0,
            //           serviceType: "S03",
            //           customerNumber: "S03-33333",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "綜警 太郎",
            //           sensorName: "玄関戸締り",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "玄関カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: true,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "綜警 S05",
            //           postedDatetime: "2022-05-20 12:00:00",
            //           contentType: 0,
            //           serviceType: "S05",
            //           customerNumber: "S05-33333",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "綜警 太郎",
            //           sensorName: "玄関戸締り",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "玄関カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: true,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "綜警 S04",
            //           postedDatetime: "2022-05-20 12:00:00",
            //           contentType: 0,
            //           serviceType: "S04",
            //           customerNumber: "S04-33333",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "綜警 太郎",
            //           sensorName: "玄関戸締り",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "玄関カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: true,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "綜警 S06",
            //           postedDatetime: "2022-05-20 12:00:00",
            //           contentType: 0,
            //           serviceType: "S06",
            //           customerNumber: "S06-33333",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "綜警 太郎",
            //           sensorName: "玄関戸締り",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "玄関カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: true,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "綜警 S07",
            //           postedDatetime: "2022-05-20 12:00:00",
            //           contentType: 0,
            //           serviceType: "S07",
            //           customerNumber: "S07-33333",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "綜警 太郎",
            //           sensorName: "玄関戸締り",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "玄関カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: true,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "綜警 S08",
            //           postedDatetime: "2022-05-20 12:00:00",
            //           contentType: 0,
            //           serviceType: "S08",
            //           customerNumber: "S08-33333",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "綜警 太郎",
            //           sensorName: "玄関戸締り",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "玄関カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: true,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-09 06:00:00",
            //           contentType: 1,
            //           serviceType: "A10",
            //           customerNumber: "A10-22222",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "玄関センサー",
            //           securityDestinationName: "自宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "玄関カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: true,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-29 20:00:00",
            //           contentType: 1,
            //           serviceType: "J02",
            //           customerNumber: "J02-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-29 20:00:00",
            //           contentType: 1,
            //           serviceType: "J04",
            //           customerNumber: "J04-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-29 20:00:00",
            //           contentType: 1,
            //           serviceType: "J06",
            //           customerNumber: "J06-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-29 20:00:00",
            //           contentType: 1,
            //           serviceType: "J10",
            //           customerNumber: "J10-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-29 20:00:00",
            //           contentType: 1,
            //           serviceType: "J11",
            //           customerNumber: "J11-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-29 20:00:00",
            //           contentType: 1,
            //           serviceType: "J13",
            //           customerNumber: "J13-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J01",
            //           customerNumber: "J01-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J03",
            //           customerNumber: "J03-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J05",
            //           customerNumber: "J05-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J07",
            //           customerNumber: "J07-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J08",
            //           customerNumber: "J08-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J09",
            //           customerNumber: "J09-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J16",
            //           customerNumber: "J16-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J12",
            //           customerNumber: "J12-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J14",
            //           customerNumber: "J14-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J15",
            //           customerNumber: "J15-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-21 20:00:00",
            //           contentType: 1,
            //           serviceType: "M02",
            //           customerNumber: "M02-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-21 20:00:00",
            //           contentType: 1,
            //           serviceType: "M03",
            //           customerNumber: "M03-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-21 20:00:00",
            //           contentType: 0,
            //           serviceType: "M02",
            //           customerNumber: "M02-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-21 20:00:00",
            //           contentType: 0,
            //           serviceType: "M03",
            //           customerNumber: "M03-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },

            //         {
            //           notificationType: 2,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-16 20:00:00",
            //           contentType: 1,
            //           serviceType: "001",
            //           customerNumber: "001-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 2,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-16 20:00:00",
            //           contentType: 1,
            //           serviceType: "002",
            //           customerNumber: "002-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 2,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-16 20:00:00",
            //           contentType: 0,
            //           serviceType: "002",
            //           customerNumber: "002-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 2,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-16 20:00:00",
            //           contentType: 1,
            //           serviceType: "003",
            //           customerNumber: "003-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 2,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-16 20:00:00",
            //           contentType: 0,
            //           serviceType: "003",
            //           customerNumber: "003-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 3,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-23 20:00:00",
            //           contentType: 0,
            //           serviceType: "HSAPP1",
            //           customerNumber: "HSAPP1-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "notificationMessage",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 3,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-23 20:00:00",
            //           contentType: 0,
            //           serviceType: "HSAPP2",
            //           customerNumber: "HSAPP2-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "notificationMessage",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 3,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-23 20:00:00",
            //           contentType: 0,
            //           serviceType: "HSAPP3",
            //           customerNumber: "HSAPP3-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "notificationMessage",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 3,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-23 20:00:00",
            //           contentType: 0,
            //           serviceType: "HSAPP4",
            //           customerNumber: "HSAPP4-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "notificationMessage",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 3,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-06-23 20:00:00",
            //           contentType: 0,
            //           serviceType: "HSAPP5",
            //           customerNumber: "HSAPP5-44444",
            //           districtSplitNumber: "aaaa",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           deviceID: "deviceID",
            //           cameraNickname: "浴室カメラ",
            //           notificationMessage: "notificationMessage",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 3,
            //           postedName: "ALSOK",
            //           postedDatetime: "2022/06/30 18:24:00.000",
            //           contentType: null,
            //           serviceType: null,
            //           customerNumber: null,
            //           districtSplitNumber: null,
            //           operatorInfo: null,
            //           sensorName: null,
            //           securityDestinationName: null,
            //           deviceID: null,
            //           cameraNickname: null,
            //           notificationMessage: "履歴ないようないよう",
            //           isNewMessageLabel: false,
            //           isPersonNotification: false,
            //         },
            //       ],
            //     },
            //     displayDistrictFilterList: [
            //       {
            //         displayDistrictNickname: "自宅",
            //         customerNumber: "1111",
            //         districtSplitNumber: "1111",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         displayDistrictNickname: "父自宅",
            //         customerNumber: "2222",
            //         districtSplitNumber: "2222",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         displayDistrictNickname:
            //           "軽井沢の別荘のとなりのマンションの最上階",
            //         customerNumber: "3333",
            //         districtSplitNumber: "3333",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         displayDistrictNickname: "祖父母宅",
            //         customerNumber: "4444",
            //         districtSplitNumber: "4444",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         displayDistrictNickname: "●●自宅",
            //         customerNumber: "5555",
            //         districtSplitNumber: "5555",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //     ],
            //     alarmTypeFilterList: {
            //       securityOperationInfo: {
            //         filterStatus: true,
            //       },
            //       intrusionInfo: {
            //         filterStatus: true,
            //       },
            //       fireInfo: {
            //         filterStatus: true,
            //       },
            //       fireRecoveryInfo: {
            //         filterStatus: true,
            //       },
            //       gasInfo: {
            //         filterStatus: true,
            //       },
            //       gasRecoveryInfo: {
            //         filterStatus: true,
            //       },
            //       emergencyInfo: {
            //         filterStatus: true,
            //       },
            //       emergencyRecoveryInfo: {
            //         filterStatus: true,
            //       },
            //       lifeRhythmInfo: {
            //         filterStatus: true,
            //       },
            //       lifeRhythmRecoveryInfo: {
            //         filterStatus: true,
            //       },
            //       equipmentInfo: {
            //         filterStatus: true,
            //       },
            //       equipmentRecoveryInfo: {
            //         filterStatus: true,
            //       },
            //       lowBatteryInfo: {
            //         filterStatus: true,
            //       },
            //       lowBatteryRecoveryInfo: {
            //         filterStatus: true,
            //       },
            //       equipmentErrorInfo: {
            //         filterStatus: true,
            //       },
            //       equipmentErrorRecoveryInfo: {
            //         filterStatus: true,
            //       },
            //       newsInfo: {
            //         filterStatus: true,
            //       },
            //       watchOverInfo: {
            //         filterStatus: true,
            //       },
            //     },
            //     cameraFilterList: [
            //       {
            //         cameraNickName: "リビングカメラ",
            //         deviceID: "aaaa",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         cameraNickName: "玄関カメラ",
            //         deviceID: "bbbb",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         cameraNickName: "熱海の祖父母宅の玄関とリビングのカメラ",
            //         deviceID: "cccc",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         cameraNickName: "父カメラ",
            //         deviceID: "cccc",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         cameraNickName: "母カメラ",
            //         deviceID: "cccc",
            //         filterStatus: false,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         cameraNickName: "息子カメラ",
            //         deviceID: "cccc",
            //         filterStatus: false,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         cameraNickName: "娘カメラ",
            //         deviceID: "cccc",
            //         filterStatus: true,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //       {
            //         cameraNickName: "犬カメラ",
            //         deviceID: "cccc",
            //         filterStatus: false,
            //         modified: "2022-05-30 12:00:00",
            //       },
            //     ],
            //     detectionTypeFilterList: {
            //       motionSensingInfo: {
            //         filterStatus: true,
            //       },
            //     },
            //     modified: "2022-05-30 23:00:00",
            //   },
            // };
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU1701>>>");
      return apiData;
    },
    /**
     * 通知履歴絞り込み設定更新処理
     */
    refineUpdate: async function () {
      this.$_setLoading(true);
      await this.APP_CU1702();
      let promiseList = [];
      promiseList.push(this.updateNotifications(this.cu9916Data));
      promiseList.push(this.saveInitInfo());
      await Promise.all(promiseList).finally(() => {
        this.$_setLoading(false);
      });
    },
    /**
     * 通知履歴絞り込み設定更新API実行処理
     */
    APP_CU1702: async function () {
      let method = 'post';
      let param = '/api/notificationHistory/updateNotificationHistoryFilter';
      // let param = "post"; // 検証用

      // 対象地区絞り込み一覧のデータ作成
      let displayDistrictFilterData = [];
      this.displayDistrictList.forEach((element, index) => {
        if (element.isChecked !== this.initInfo.displayDistrictList[index].isChecked) {
          displayDistrictFilterData.push({
            customerNumber: element.customerNumber,
            districtSplitNumber: element.districtSplitNumber,
            filterStatus: element.isChecked,
            modified: element.modified,
          });
        }
      });

      // カメラ絞り込み一覧のデータ作成
      let cameraFilterData = [];
      this.cameraList.forEach((element, index) => {
        if (element.isChecked !== this.initInfo.cameraList[index].isChecked) {
          cameraFilterData.push({
            deviceID: element.deviceID,
            filterStatus: element.isChecked,
            modified: element.modified,
          });
        }
      });

      // 警報種別データ作成
      let alarmTypeFilterData = {};
      const alarmKeyList = [
        'securityOperationInfo',
        'intrusionInfo',
        'fireInfo',
        'fireRecoveryInfo',
        'gasInfo',
        'gasRecoveryInfo',
        'emergencyInfo',
        'emergencyRecoveryInfo',
        'lifeRhythmInfo',
        'lifeRhythmRecoveryInfo',
        'equipmentInfo',
        'equipmentRecoveryInfo',
        'lowBatteryInfo',
        'lowBatteryRecoveryInfo',
        'equipmentErrorInfo',
        'equipmentErrorRecoveryInfo',
        'watchOverInfo',
        'newsInfo',
      ];
      this.alarmList.forEach((element, index) => {
        alarmTypeFilterData[alarmKeyList[index]] = {
          filterStatus: element.isChecked,
        };
      });

      // 検知種別データ作成
      let detectionTypeFilterData = {};
      if (this.detectionList[0].isChecked !== this.initInfo.detectionList[0].isChecked) {
        detectionTypeFilterData['motionSensingInfo'] = {
          filterStatus: this.detectionList[0].isChecked,
        };
      }

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo'),
        displayDistrictFilterList: displayDistrictFilterData,
        alarmTypeFilterList: alarmTypeFilterData,
        cameraFilterList: cameraFilterData,
        detectionTypeFilterList: detectionTypeFilterData,
        modified: this.modified,
      };
      let successFlag = false;

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            successFlag = true;
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
      // console.log("APP_CU1702>>>");

      if (!successFlag) {
        this.switchLabel(
          this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.対象地区'),
          this.displayDistrictList
        );
        this.switchLabel(
          this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.警報種別'),
          this.alarmList
        );
        this.switchLabel(
          this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.カメラ'),
          this.cameraList
        );
        this.switchLabel(
          this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.検知種別'),
          this.detectionList
        );
      }
    },
    /**
     * 通知履歴絞り込みコンポーネントすべて選択処理
     * @param {String} title 通知履歴絞り込みコンポーネントタイトル
     */
    selectAll: function (title) {
      this.setSelectAll(title, true);
    },
    /**
     * 通知履歴絞り込みコンポーネントクリア処理
     * @param {String} title 通知履歴絞り込みコンポーネントタイトル
     */
    clearAll: function (title) {
      this.setSelectAll(title, false);
    },
    /**
     * 通知履歴絞り込みコンポーネント全変更処理
     * @param {String} title 通知履歴絞り込みコンポーネントタイトル
     * @param {Boolean} isChecked チェック済みにするかどうか
     */
    setSelectAll: function (title, isChecked) {
      if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.種別')) {
        // 種別
        this.categoryList.map((item) => {
          if (!item.isDisabled) item.isChecked = isChecked;
        });
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.対象地区')) {
        // 対象地区
        this.displayDistrictList.map((item) => (item.isChecked = isChecked));
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.警報種別')) {
        // 警報種別
        this.alarmList.map((item) => (item.isChecked = isChecked));
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.カメラ')) {
        // カメラ
        this.cameraList.map((item) => (item.isChecked = isChecked));
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.検知種別')) {
        // 検知種別
        this.detectionList.map((item) => (item.isChecked = isChecked));
      }
    },
    /**
     * 通知履歴絞り込みコンポーネント適用処理
     * @param {String} title 通知履歴絞り込みコンポーネントタイトル
     * @param {Array} list 通知履歴絞り込みコンポーネント選択状態
     */
    apply: function (title, list) {
      if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.種別')) {
        // 種別
        this.categoryList = list;
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.対象地区')) {
        // 対象地区
        list.forEach((element, index) => {
          this.displayDistrictList[index].isChecked = element.isChecked;
        });
        this.displayDistrictDialog = !this.displayDistrictDialog;
        this.switchLabel(title, list);
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.警報種別')) {
        // 警報種別
        list.forEach((element, index) => {
          this.alarmList[index].isChecked = element.isChecked;
        });
        this.alarmDialog = !this.alarmDialog;
        this.switchLabel(title, list);
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.カメラ')) {
        // カメラ
        list.forEach((element, index) => {
          this.cameraList[index].isChecked = element.isChecked;
        });
        this.cameraDialog = !this.cameraDialog;
        this.switchLabel(title, list);
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.検知種別')) {
        // 検知種別
        list.forEach((element, index) => {
          this.detectionList[index].isChecked = element.isChecked;
        });
        this.detectionDialog = !this.detectionDialog;
        this.switchLabel(title, list);
      }
    },
    /**
     * 通知履歴絞り込みコンポーネントキャンセル処理
     * @param {*} title 通知履歴絞り込みコンポーネントタイトル
     */
    cancel: function (title) {
      if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.対象地区')) {
        // 対象地区
        this.initInfo.displayDistrictList.forEach((element, index) => {
          this.displayDistrictList[index].isChecked = element.isChecked;
        });
        this.displayDistrictDialog = !this.displayDistrictDialog;
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.警報種別')) {
        // 警報種別
        this.initInfo.alarmList.forEach((element, index) => {
          this.alarmList[index].isChecked = element.isChecked;
        });
        this.alarmDialog = !this.alarmDialog;
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.カメラ')) {
        // カメラ
        this.initInfo.cameraList.forEach((element, index) => {
          this.cameraList[index].isChecked = element.isChecked;
        });
        this.cameraDialog = !this.cameraDialog;
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.検知種別')) {
        // 検知種別
        this.initInfo.detectionList.forEach((element, index) => {
          this.detectionList[index].isChecked = element.isChecked;
        });
        this.detectionDialog = !this.detectionDialog;
      }
    },
    /**
     * 各ダイアログのラベルの表示を判定
     * @param {*} title 通知履歴絞り込みコンポーネントタイトル
     * @param {*} list 通知履歴絞り込みコンポーネント選択状態
     */
    switchLabel: function (title, list) {
      let checkCounter = 0;
      let displayText = '';
      list.forEach((element) => {
        if (element.isChecked) {
          checkCounter++;
          displayText = element.label;
        }
      });

      if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.対象地区')) {
        // 対象地区
        this.displayDistrictDialogText =
          checkCounter <= 1
            ? displayText
            : checkCounter < list.length
            ? '$vuetify.FECU17通知履歴画面.複数選択中'
            : '$vuetify.FECU17通知履歴画面.全て';
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.警報種別')) {
        // 警報種別
        this.alarmDialogText =
          checkCounter <= 1
            ? displayText
            : checkCounter < list.length
            ? '$vuetify.FECU17通知履歴画面.複数選択中'
            : '$vuetify.FECU17通知履歴画面.全て';
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.カメラ')) {
        // カメラ
        this.cameraDialogText =
          checkCounter > 0
            ? checkCounter == 1
              ? displayText
              : checkCounter < list.length
              ? '$vuetify.FECU17通知履歴画面.複数選択中'
              : '$vuetify.FECU17通知履歴画面.全て'
            : '';
      } else if (title === this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.検知種別')) {
        // 検知種別
        this.detectionDialogText =
          checkCounter > 0
            ? checkCounter == 1
              ? displayText
              : checkCounter < list.length
              ? '$vuetify.FECU17通知履歴画面.複数選択中'
              : '$vuetify.FECU17通知履歴画面.全て'
            : '';
      }
    },
    /**
     * 戻る処理
     */
    onPressBackBtn() {
      this.$router.back();
    },
  },
  beforMount() {
    this.$_setLoading(true);
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.$_pvCount(PAGE_ID);
    this.tabNumber = this.$store.state.notificationHistoryTabNumber;

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }
    this.isShowPage = true; //#27159
    this.$store.commit('setCameraTotal', {
      cameraTotal: -1,
    });

    const method = 'post';
    const queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo'),
    };
    await this.init(queries, method);

    // remove open notification from panel flag
    if (sessionStorage.removeItem('redirectPath') === '/notificationHistory') {
      sessionStorage.removeItem('redirectPath');
    }
  },
  beforeUpdate() {
    this.isShowPage = true; //#27159
  },
  updated() {
    this.isShowPage = true; //#27159
  },
};
